module.exports = __webpack_public_path__ + "assets/img/tx180t.07f0a81b.jpg";